/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { ReactElement } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { sanitize } from '@bamboohr/utils/lib/dom';

export const squeakyClean = (input: string): ReactElement[] => {
	return ReactHtmlParser(sanitize(input));
};
